import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "booking-service";

export default {
    getInstructors(param) {
        return new Promise((resolve, reject) => {
            api.post(
                // Check what method is used
                BASE_SERVICE_URL + "/cms/booking/instructor/list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveInstructor(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/cms/booking/instructor/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    viewInstructor(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/cms/booking/instructor/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteInstructor(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                BASE_SERVICE_URL + "/cms/booking/instructor/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateInstructor(uuid, param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/cms/booking/instructor/update/" + uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getRatings(param) {
        return new Promise((resolve, reject) => {
            api.post(
                // Check what method is used
                BASE_SERVICE_URL + "/cms/booking/rating/instructor/page/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getComments(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/cms/booking/comments/instructor/page/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
};
